export default {
    car: {
        gasConsumption: '7',
        gasPrice: '1.600',
    },
    camper: {
        gasConsumption: '9.5',
        gasPrice: '1.600',
    },
    trailer: {
        gasConsumption: '9.5',
        gasPrice: '1.600',
    },
    motorcycle: {
        gasConsumption: '4.5',
        gasPrice: '1.600',
    },
}